import styled from 'styled-components';
import React, { useEffect } from 'react';
import { replace as Replace } from 'redux-first-history';
import { useDispatch, useSelector } from 'react-redux';
import { stringify } from 'query-string';
import { Dialog as MaterialDialog, Grid, Portal } from '@material-ui/core';
import { palette } from '@dev/ee-components';
import { Preview } from '@dev/ee-modules';
import { SetToastPortalWrapper } from '@/store/toast/actions';
import { getTemplateList, TemplatePreviewStart } from '@/store/templateList/actions';
import { ApplicationState, getConfigStore } from '@/store';
import { getAccountStore } from '@/store/account/actions';
import { useGetCampaignInfo } from '@/components/CampaignCreator/hooks/useGetCampaignInfo';
import { ClosePreviewOverlay, EditCampaignTemplate, getCampainCreatorStore } from '@/store/campaignCreator/actions';

const Overlay = styled.div`
    background: ${palette.snow[1]};
    height: max-content;

    .MuiContainer-root {
        padding-top: 60px;
    }
`;

export const PreviewOverlay = (): JSX.Element => {
    const dispatch = useDispatch();

    const config = useSelector(getConfigStore);
    const account = useSelector(getAccountStore);
    const browser = useSelector((state: ApplicationState) => state.browser);
    const templateList = useSelector(getTemplateList);
    const { template } = useGetCampaignInfo();
    const templateName = template ?? templateList.name;
    const { isPreviewOverlayOpen, isGalleryOpen } = useSelector(getCampainCreatorStore);

    useEffect(() => {
        if (!isPreviewOverlayOpen) return;
        dispatch(SetToastPortalWrapper(true));
        return () => {
            dispatch(SetToastPortalWrapper(false));
        };
    }, [isPreviewOverlayOpen]);

    const templatePreviewStart = (templateName: string, isPublic: boolean) => {
        dispatch(TemplatePreviewStart(templateName, isPublic));
    };
    const setToastPortalWrapper = (isInsidePortal: boolean) => dispatch(SetToastPortalWrapper(isInsidePortal));
    const closePreviewOverlay = () => dispatch(ClosePreviewOverlay());

    const onEditClick = () => {
        const currentTemplate = templateList?.templatesList?.find(tmpl => tmpl.Name === templateName);
        const urlQueryParams = { isPublic: currentTemplate?.IsPublic };
        dispatch(EditCampaignTemplate(templateName, currentTemplate?.TemplateType, currentTemplate?.IsPublic, true));
        dispatch(Replace({ search: stringify(urlQueryParams as any) }));
        dispatch(ClosePreviewOverlay());
    };

    if (templateList.PreviewLoading || !isPreviewOverlayOpen) {
        return null;
    }

    return (
        <Portal>
            <MaterialDialog open fullScreen>
                <Overlay>
                    <Grid container justifyContent="center" style={{ padding: '0px 16px' }}>
                        <Grid item xs={12} sm={12} style={{ maxWidth: 1170, paddingBottom: 16 }}>
                            <Preview
                                browser={browser}
                                account={account}
                                rawEditor={templateList}
                                config={config}
                                TemplatePreviewStart={templatePreviewStart}
                                SetToastPortalWrapper={setToastPortalWrapper}
                                ClosePreviewOverlay={closePreviewOverlay}
                                campaignTemplate={templateName}
                                onEditClick={onEditClick}
                                isPreviewEditable={isGalleryOpen}
                            />
                        </Grid>
                    </Grid>
                </Overlay>
            </MaterialDialog>
        </Portal>
    );
};
